import { makeLimitedListActions } from 'utils/factory'

const baseListActions = makeLimitedListActions('subscribers')

export const fetchNextSubscriberList = baseListActions.fetchNext
export const dropSubscribersList = baseListActions.drop

export const fetchSubscriberList = (query) => {
  return (dispatch) => {
    const body = { ...query }
    return dispatch(baseListActions.fetch(null, body))
  }
}
